var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-height traveler-data" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "traveler-complaint-remind",
            "append-to-body": "",
            title: "客訴備註",
            visible: _vm.dialogFormVisibleByComplaintMemo,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisibleByComplaintMemo = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "complaintRemindForm",
              attrs: { model: _vm.complaintRemindForm, size: "mini" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "complaintRemind" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 10 },
                    model: {
                      value: _vm.complaintRemindForm.complaintRemind,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.complaintRemindForm,
                          "complaintRemind",
                          $$v
                        )
                      },
                      expression: "complaintRemindForm.complaintRemind",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "success" },
                  on: { click: _vm.saveComplaint },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisibleByComplaintMemo = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            title: "編輯旅客",
            visible: _vm.dialogFormVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "110px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旅客姓名", prop: "travelName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "請輸入旅客姓名", clearable: "" },
                    model: {
                      value: _vm.formData.travelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "travelName", $$v)
                      },
                      expression: "formData.travelName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "旅客生日", prop: "birthDay" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "選擇生日",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.formData.birthDay,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "birthDay", $$v)
                      },
                      expression: "formData.birthDay",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "手機號碼", prop: "mobile" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "請輸入手機號碼", clearable: "" },
                    model: {
                      value: _vm.formData.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "mobile", $$v)
                      },
                      expression: "formData.mobile",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "E-mail", prop: "mail" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "請輸入 E-mail", clearable: "" },
                    model: {
                      value: _vm.formData.mail,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "mail", $$v)
                      },
                      expression: "formData.mail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "身分證字號", prop: "idCard" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "請輸入身分證字號", clearable: "" },
                    model: {
                      value: _vm.formData.idCard,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "idCard", $$v)
                      },
                      expression: "formData.idCard",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "護照英文姓名", prop: "passportEnName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "例如：WANG, XIAO-MING",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formData.passportEnName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "passportEnName", $$v)
                      },
                      expression: "formData.passportEnName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "護照號碼", prop: "passportNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "請輸入護照號碼", clearable: "" },
                    model: {
                      value: _vm.formData.passportNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "passportNo", $$v)
                      },
                      expression: "formData.passportNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "旅行社備註", prop: "agencyRemind" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "請輸入旅行社備註",
                      clearable: "",
                    },
                    model: {
                      value: _vm.formData.agencyRemind,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "agencyRemind", $$v)
                      },
                      expression: "formData.agencyRemind",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "success" },
                  on: { click: _vm.saveData },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入旅客姓名" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "formDetailsTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                size: "mini",
                border: "",
                fit: "",
                height: "100%",
                "row-class-name": _vm.tableRowStatus,
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "數量",
                  width: "1",
                  type: "expand",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "mini",
                              data: scope.row.travels,
                              border: "",
                              height: "200",
                              "row-class-name": _vm.tableRowClassName,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "",
                                "min-width": 50,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "14px",
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.travelName))]
                                        ),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "el-tag",
                                              { attrs: { size: "mini" } },
                                              [
                                                _vm._v(" 出發 "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        "" + scope.row.beginDate
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" - 回程 "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        "" + scope.row.endDate
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                label: "",
                                "min-width": 50,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "center",
                                              gap: "0 8px",
                                            },
                                          },
                                          [
                                            _c("p", [_vm._v("滿意度")]),
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: {
                                                  "font-size": "20px",
                                                  "font-weight": "bold",
                                                },
                                                attrs: {
                                                  type: _vm.getSatisfactionAnalysisStyle(
                                                    scope.row.satisfactionPoint
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row
                                                        .satisfactionPoint
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "姓名", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(" " + _vm._s(row.travelName) + " "),
                          row.passportEnName && row.passportEnName.trim() !== ""
                            ? _c("span", [
                                _vm._v(
                                  " " + _vm._s(" " + row.passportEnName) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "生日", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.birthDay))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "手機號碼", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.mobile))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "E-MAIL", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.mail))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "身分證字號", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.idCard))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "護照號碼", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.passportNo))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "護照照片", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.passportUrl && !scope.row._imgError
                          ? _c("el-image", {
                              staticStyle: { width: "80px", height: "auto" },
                              attrs: {
                                src: scope.row.passportUrl,
                                "preview-src-list": [scope.row.passportUrl],
                                fit: "contain",
                              },
                              on: {
                                error: function ($event) {
                                  scope.row._imgError = true
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "旅行社備註", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.agencyRemind))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "領隊備註", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.leaderRemind))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "出團數", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticStyle: {
                              "font-size": "15px",
                              "font-weight": "bold",
                              cursor: "pointer",
                            },
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.toggleExpand(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.toursCount) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "客訴", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title: "確定要變更客訴狀態嗎？",
                              "cancel-button-text": "取消",
                              "confirm-button-text": "確定",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleCheckComplaint(scope.row)
                              },
                            },
                          },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                slot: "reference",
                                value: scope.row.hasComplaint,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "客訴備註", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.ComplaintMemo(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 編輯 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "資料編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 編輯 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }